var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "repeat_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#repeat_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M21.5 11c0-1.809-.631-3.345-1.893-4.607S16.809 4.5 15 4.5H9c-1.809 0-3.345.631-4.607 1.893S2.5 9.191 2.5 11c0 1.633.53 3.058 1.592 4.275 1.062 1.217 2.401 1.938 4.018 2.163a.786.786 0 0 0 .622-.147A.636.636 0 0 0 9 16.76a.68.68 0 0 0-.265-.548 1.39 1.39 0 0 0-.62-.289c-1.207-.215-2.195-.785-2.963-1.71C4.384 13.29 4 12.218 4 11c0-1.383.488-2.563 1.463-3.538C6.438 6.487 7.617 6 9 6h6c1.383 0 2.563.487 3.538 1.462C19.512 8.437 20 9.617 20 11c0 1.39-.486 2.572-1.458 3.547-.972.975-2.152 1.463-3.542 1.463l-.771-.01 1.313-1.313a.698.698 0 0 0 .208-.515.724.724 0 0 0-.223-.53.717.717 0 0 0-.527-.217.717.717 0 0 0-.527.217l-2.485 2.485a.867.867 0 0 0-.27.633c0 .24.09.451.27.632l2.495 2.495c.138.138.31.207.514.207.205 0 .381-.07.53-.207a.698.698 0 0 0 .228-.535.747.747 0 0 0-.228-.535l-1.308-1.307H15c1.809 0 3.345-.633 4.607-1.899C20.869 14.346 21.5 12.81 21.5 11Z",
    fill: "currentColor"
  }))));
};
export default SvgRepeat;